import styled from 'styled-components';
import articleRowBackground from "../assets/images/patt.png";
import backgroundImage from "../assets/images/newsheader.jpg";
import {Container, Card, Col, Row, Carousel} from "react-bootstrap";
import {Link} from "react-router-dom";


export const HomeContentContainer = styled(Container)`
    @media(min-width: 900px) {
        max-width: 860px;
    }
    @media(min-width: 1200px) {
        max-width: 1140px;
    }
    @media(min-width: 1440px) {
        max-width: 1400px;
    }
`

export const HomeContentRow = styled(Row)`
    margin-top: 50px;
    background-color: #fff;
`;

// Carousel

export const StyledCarousel = styled(Carousel)`
    display: none;
    @media (min-width: 640px) {
        display: block;
        min-height: 343px;
    }
`;

export const StyledCaption = styled(Carousel.Caption)`
        background: rgb(36,122,41);
        background: linear-gradient(0deg, rgba(36,122,41,1) 0%, rgba(36,122,41,0.7539609593837535) 68%, rgba(36,122,41,0) 100%);
        text-shadow: #0a2b1d 1px 2px;
        right: 0%;
        left: 0%;
        bottom: 0rem;
        min-height: 12rem;
        & H1 {
            font-size: 2.5rem;
        }
        & .subtitle {
            text-transform: uppercase;
            font-size: 0.8rem;
        }
    `;



// Sections
export const HomeSectionTitle = styled.div`
    color: #689f38;
    text-transform: uppercase;
    font-family: 'droidSans', sans-serif;
    font-size: 14px;
    position: relative;
`;

export const HomeSectionType = styled.div`
    color: #222;
    font-family: 'Roboto Slab', sans-serif;
    font-weight: 700;
    font-size: 2.5rem;
    position: relative;
`;


// Home news elements --------------------------
export const StyledNewsItem = styled.div`
    padding-bottom: 10px;
    margin-top: 10px;
`;

export const StyledNewsItemThumb = styled.div`
    float: left;
    width: 100%;
    margin-right: 10px;
    border-radius: 5px;
    overflow: hidden;
    cursor:pointer;

    & img {
        width: 100%;
    }
`;

export const StyledNewsItemTitle = styled.div`
    margin: 5px;

    & h5 a {
        color: #222;
        text-decoration: none;
        font-family: 'Roboto Slab', sans-serif;
        font-weight: bold;
        font-size: 24px;
        cursor:pointer;
    }

    & h5 a:hover {
        color: green;
    }

    & p {
        font-family: 'Poppins', sans-serif;
        font-weight: 400;
    }

    & ul.post-meta li {
        display: inline-flex;
        font-size: 0.9rem;
    }

    & ul.post-meta li span {
        color: #689f38;
    }
`;



export const StyledEventRow = styled(Row)`
    padding-left: 0;
    padding-right: 0;
    width:100%;
    cursor: pointer;
`;

export const StyledEventPost = styled.div`
    width: 100%;
    float: left;
    border-radius: 5px;
    background: #fff;
    overflow: hidden;
    padding-left: 0;
    padding-right: 0;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
    margin-bottom: 40px;
`;

export const StyledEventThumb = styled(Col)`
    width: 100%;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    & img {
        width: 100%;
    }
    & div.post-meta {
        position: absolute;
        left: 0px;
        bottom: 0px;
        min-height: 30px;
        width: 100%;
        background-color: rgba(0,0,0,0.3);
        z-index: 99;
        text-align: center;
    }
    & ul.post-meta {
        list-style: none;
        margin: 0 0 8px;
    }
    & ul.post-meta li {
        display: inline-block;
        color: #fff;
        text-shadow: 1px 1px #000;
        padding: 5px;
    }
`;

export const StyledEventText = styled.div`
    text-align: center;
    padding: 1rem;
    & h6 {
        margin-top: 20px;
    }
    & h6 a {
        font-family: "Roboto Slab", serif;
        font-size: 20px;
        text-decoration: none;
        font-weight: bold;
        color: #222;
        letter-spacing: -0.2px;
    }
    & a:hover {
        color: green;
    }
`;

// articles


export const ArticleDiv = styled.div`
    background-image: url(${articleRowBackground});
    padding-top: 25px;
    width: 100%;
`;

export const StyledArticleContainer = styled(Container)`
    padding-bottom: 50px;
    @media(min-width: 900px) {
        max-width: 860px;
    }
    @media(min-width: 1200px) {
        max-width: 1140px;
    }
    @media(min-width: 1440px) {
        max-width: 1400px;
    }
`;





// END HOME ELEMENTS -------------------------

export const StyledSectionHeader = styled.section`
    background: #2a5934 url(${backgroundImage});
    background-size: cover;
    text-align: left;
    @media(min-width: 300px) {
        & .section-title {
            color: #fff;
            text-shadow: 1px 1px 5px #000;
            font-weight: bold;
            font-size: 1.5rem;
            padding-top: 1rem;
            padding-bottom: 1rem;
        }
    }
    @media(min-width: 600px) {
        padding: 50px 0;
        width: 100%;
        float: left;
        display: block;
        & .section-title {
            color: #fff;
            text-shadow: 1px 1px 5px #000;
            font-weight: bold;
            font-size: 2rem;
        }
    }
    @media(min-width: 1100px) {
        min-height: 250px;
        padding: 100px 0;
        width: 100%;
        float: left;
        display: block;
        & .section-title {
            color: #fff;
            text-shadow: 1px 1px 5px #000;
            font-weight: bold;
            font-size: 4rem;
        }
    }
`;

export const StyledSectionHeaderComponent = ({title}) => {
    return (
        <StyledSectionHeader>
            <div className="container">
                <h1 className="section-title">{title}</h1>
            </div>
        </StyledSectionHeader>
    )
}

export const StyledListContainer = styled(Container)`
    max-width: 1170px;
`;

export const StyledListSection = styled.section`
    min-height: 50vh;
`;


export const ListItemContainer = styled.div`
    max-width: 1140px;
    cursor: pointer;
`;


export const ListItemDate = styled(Col)`
    text-align: center;
    & h4 {
        margin: 15px 0 10px;
        font-family: "Roboto Slab", serif;
        font-weight: 700;
        text-transform: uppercase;
    }
    & h1 {
        margin: 15px 0 10px;
        font-family: "Roboto Slab", serif;
        font-weight: 700;
        font-size: 4rem;
    }
`;

export const ListItemText = styled(Col)`
& h4 {
        margin: 15px 0 10px;
        font-family: "Roboto Slab", serif;
        font-weight: 700;
        text-transform: uppercase;
    }
    & h2 {
        margin: 15px 0 10px;
        font-family: "Roboto Slab", serif;
        font-weight: 700;
    }
`;

export const ListItemLink = styled(Link)`
    text-decoration: none;
    color: #2a5934;
    
    border-radius: 5px;
    display: inline-block;
    font-weight: bold;
    text-transform: uppercase;
    font-family: "droidSans", sans-serif;
    font-size: 14px;
    cursor: pointer;
    &:hover {
        color: var(--moss-green);
    }
`;


export const ListItemContainerRow = styled(Row)`
    
`;

export const ListItemThumb = styled.div`
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    overflow: hidden;
    & img {
        width: 100%;
    }
`;

export const StyledListSideBarColumn = styled(Col)`
    padding-left: 4vw;
    padding-right: 0;
`;

export const EventListItemContainerRow = styled(Row)`
    box-shadow: 0 6px 20px rgba(0, 0, 0, .15);
    margin-bottom: 40px;
    border-radius: 5px;
    overflow: hidden;
    padding: 5px;
    padding-left: 0;
    padding-right: 0;
    cursor: pointer;
`;


export const StyledMembershipCard = styled(Card)`
  margin-bottom: 2rem;
  .card-header {
    background-color: #2c5530;
    color: white;
    font-weight: bold;
  }
  .card-body {
    background-color: #efefef;
    align-items: center;
    & a {
      color: #2c5530;
    }
  }
`;

export const StyledBankDetails = styled(Card)`
  margin-bottom: 2rem;
  background-color: #efefef;
  .card-header {
    background-color: #2c5530;
    color: white;
    font-weight: bold;
  }
`;

export const StyledAddress = styled.div`
  background-color: #fff;
  color: #000;
  padding: 1rem;
  border-radius: 5px;
`;

export const StyledTitle = styled.h2`
  font-family: "Roboto Slab", serif;
  font-weight: bold;
  color: var(--forest-green);
`;

export const PostMeta = styled(Container)`
`;

export const StyledIntro = styled.section`
    margin-top: 2rem;
`;

export const StyledBody = styled.section`
    margin-top: 2rem;
`;


export const StyledEmergencyHeader = styled.div`
    margin-top: 25px;
    border-color: red;
    border-width: 2px;
    border-style: solid;
    font-family: "Roboto Slab", serif;
    font-weight: 700;
    padding: 10px;
    border-radius: 5px;
    margin-bottom: 25px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    & p {
        font-family: "Poppins", sans-serif;
        font-weight: 400;
        font-size: 1rem;
    }
`;


export const NewsListPostMeta = styled.div`
    display: inline;
    list-style: none;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    width: 100%;
    font-size: 0.8rem;
    & ul {
        list-style: none;
        display: inline;
        margin: 0;
        padding: 0;
        li {
            display: inline-block;
            color: #666;
            margin-right: 1rem;
        }
    }

    & i {
        color: #38a935;
        margin-right: 5px;
    }
`;

export const NewsListStyledIntro = styled.div`
    margin-top: 10px;
    margin-bottom: 25px;
`;
    


export const StyledArticleItem = styled.div`
    padding-bottom: 10px;
    margin-top: 10px;
    border-bottom: dotted 1px #666;
`;

export const StyledArticleItemThumb = styled.div`
    float: left;
    width: 100%;
    margin-right: 10px;
    border-radius: 5px;
    overflow: hidden;
    cursor:pointer;

    & img {
        width: 100%;
    }
`;

export const StyledArticleItemTitle = styled.div`
    margin: 5px;

    & h5 a {
        color: #222;
        text-decoration: none;
        font-family: 'Roboto Slab', sans-serif;
        font-weight: bold;
        font-size: 24px;
        cursor:pointer;
    }

    & h5 a:hover {
        color: green;
    }

    & p {
        font-family: 'Poppins', sans-serif;
        font-weight: 400;
    }

    & ul.post-meta li {
        display: inline-flex;
        font-size: 0.9rem;
    }

    & ul.post-meta li span {
        color: #689f38;
    }
`;

export const EventItemPostMeta = styled.ul`
  display: inline;
  list-style: none;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  width: 100%;
  text-align: center;
  margin-bottom: 2rem;

  & li i {
    color: #38a935;
    margin-right: 5px;
  }

  & li.post-meta-item {
    display: inline;
    margin-right: 2rem;
    font-size: 0.9rem;
    color: #666;
  }
`;

export const EventItemTitle = styled.div`
  margin-top: 25px;
  color: var(--forest-green);
  & h2 {
    font-family: "Roboto Slab", serif;
    font-weight: bold;
  }
`;

export const EventItemContainer = styled.div`
    max-width: 1140px;
`;

export const EventItemDetailHeader = styled.div`
    box-shadow: 0 6px 20px rgba(0, 0, 0, .15);
    margin-bottom: 2rem;
    border-radius: 5px;
    overflow: hidden;
`;

export const EventShareButtonsCol = styled(Col)`
    padding-right: 2rem;
`
export const EventItemBodySection = styled.section`
    margin-top: 2rem;
    padding-left: 2rem;
    padding-right: 2rem;
`;

export const SidebarBoxGrey = styled.div`
    background-color: #f5f5f5;
    padding: 20px;
    border-radius: 5px;
    margin-bottom: 25px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    & h6 {
        margin: 0 0 15px;
        font-family: "Roboto Slab", serif;
        font-weight: 700;
        text-transform: uppercase;
        font-size: 1.3rem;
    }
    & p {
        margin: 0;
        font-family: "Poppins", sans-serif;
        font-weight: 400;
    }
    & .sidebar-button {
        cursor: pointer;
        background-color: #2a5934;
        color: #fff;
        display: inline-block;
        margin: 15px 0 0;
        padding: 10px 20px;
        border: 1px solid #222;
        border-radius: 5px;
        text-decoration: none;
        text-transform: uppercase;
        font-family: "Poppins", sans-serif;
        font-weight: 400;
    }
`;


export const ArticleListTagDiv = styled.div`
    margin-bottom: 2rem;
    background-color: #f0f0f0;
    border-radius: 5px;
    .tag-pill {
        background-color: #2c5530;
        color: white;
        font-weight: bold;
        font-size: 1.2rem;
        padding: 4px 8px;
        border-radius: 4px;
        text-decoration: none;
        display: inline-block;
    }
    .clear-filter {
        float: right;
        font-size: 1rem;
        text-decoration: none;
    }
`;

export const ArticleListTag = styled(Card)`
    margin-bottom: 2rem;
    background-color: #f0f0f0;
    border: none;
    border-radius: 5px;

    .tag-pill {
        background-color: #2c5530;
        color: white;
        font-weight: bold;
        font-size: 1.2rem;
        padding: 4px 8px;
        border-radius: 4px;
        text-decoration: none;
        display: inline-block;
    }
    .clear-filter {
        float: right;
        font-size: 1rem;
        text-decoration: none;
    }
`;

export const NewsListContainer = styled.div`
        padding-right: 10px;
`;



export const NewsItemTitle = styled.div`
    margin-top: 25px;
    color: var(--forest-green);
    & h2 {
        font-family: "Roboto Slab", serif;
        font-weight: bold;
    }
`;

export const NewsItemMainImageCaption = styled.div`
    background-color: #fff;
    font-style: italic;
    font-size: 0.8rem;
    padding-left: 5px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    border-top: solid 2px #0a2b1d;
`;

export const NewsItemPostMeta = styled.div`
    display: inline;
    list-style: none;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    width: 100%;
    text-align: center;
    & i {
        color: #38a935;
        margin-right: 5px;
    }

    & .post-meta-item {
        display: inline;
        margin-right: 2rem;
        font-size: 0.9rem;
        color: #666;
    }
`;



export const ArticleListContainer = styled.div`
    padding-right: 10px;
    & div:last-child {
        border-bottom: none;
    }
`;

export const StaticBodySectionHeader = styled.h3`
   font-family: "Roboto Slab", serif;
   font-weight: bold;
   font-size: 1.5rem;
   margin-top: 3rem;
   margin-bottom: 1rem;
   color: var(--forest-green);
`;

export const StyledBodySectionHeader = styled.h4`
   font-family: "Roboto Slab", serif;
   font-weight: bold;
   font-size: 1.5rem;
   margin-top: 3rem;
   margin-bottom: 1rem;
   color: var(--forest-green);
`;